module.exports = __webpack_public_path__ + "static/media/btn_primaryschool_05_video.91cd6d5f.png";